module.exports = __webpack_public_path__ + "img/9000.9cd8af4d.jpg";